import { call, put } from 'redux-saga/effects';
import { fetchBrandsCallOptions } from '../../../services/brands.services';
import { callApi } from '../../api';
import { normalize, schema } from 'normalizr';
import { updateBrandEntities } from './brands.actions';

export const brandSchema = new schema.Entity('brand', undefined, {
  idAttribute: 'id',
});

export function* fetchAllBrandsForAppId(appId: number) {
  const { ok, data } = yield call(callApi, fetchBrandsCallOptions(appId));
  const normalized = normalize(data, [brandSchema]);
  if (ok) {
    yield put(
      updateBrandEntities({ appId, brands: normalized.entities.brand })
    );
  }
}



// WEBPACK FOOTER //
// ./src/store/Entities/Brands/brands.saga.ts